var web =
webpackJsonp_name_([0],{

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _main = __webpack_require__(134);

__webpack_require__(138);

var settings = __webpack_require__(160);

var web = new _main.App(settings, function (context) {
  web.landing.bindAll(context);
  web.imageLoader.bindAll(context);
  web.landingsTable.bindAll(context);
});

$(document).ready(function () {
  var Landing = __webpack_require__(161);
  web.landing = new Landing(web);

  var ImageLoader = __webpack_require__(162);
  web.imageLoader = new ImageLoader(web);

  var LandingsTable = __webpack_require__(163);
  web.landingsTable = new LandingsTable(web);

  web.bindAll();
});

module.exports = web;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _popover = __webpack_require__(135);

var _modal = __webpack_require__(136);

var _custom = __webpack_require__(137);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global web, moment */
var App = exports.App = function () {
  function App(settings, onBindAll) {
    _classCallCheck(this, App);

    this.settings = settings || null;
    this.blocked = false;

    this.onBindAll = onBindAll || false;

    if (_popover.Popover) {
      this.popover = new _popover.Popover(this, this.settings);
    }

    if (_modal.WebModal) {
      this.modal = new _modal.WebModal(this, this.settings.modal);
    }

    if (_custom.CustomModule) {
      this.custom = new _custom.CustomModule(this);
    }
  }

  _createClass(App, [{
    key: 'resetForm',
    value: function resetForm(selector) {
      $(selector).find('input:text, input:password, input:file, select, textarea').val('');
      $(selector).find('input:radio, input:checkbox').removeAttr('checked').removeAttr('selected');
    }
  }, {
    key: 'iniDatePicker',
    value: function iniDatePicker(selector) {
      var self = this;
      $(selector).on('click', function () {
        var that = this;

        if ($(this).data('inline')) {
          $(that).parent().append("<i class='datepicker icon icon-calendar'></i>");
        }

        var options = {
          format: $(this).data('format') || 'Y-m-d',
          lang: $(this).data('lang') || 'es',
          timepicker: $(this).data('timepicker') || false,
          weeks: $(this).data('weeks') || false,
          inline: $(this).data('inline') || false,
          defaultDate: $(this).data('default') || false,
          defaultTime: $(this).data('default-time') || false,
          dayOfWeekStart: 1,
          closeOnDateSelect: true,
          onGenerate: function onGenerate(ct, $i) {
            if ($(that).data('ongenerate')) {
              self._runFuncByName($(that).data('ongenerate'), window, { 'date': ct.dateFormat(options.format), 'selector': $(this) });
            }
          },
          onSelectDate: function onSelectDate(ct) {
            if ($(that).data('onselect')) {
              self._runFuncByName($(that).data('onselect'), window, { 'date': ct.dateFormat(options.format) });
            }
          },
          onChangeMonth: function onChangeMonth(ct) {
            if ($(that).data('onchangemonth')) {
              self._runFuncByName($(that).data('onchangemonth'), window, { 'date': ct.dateFormat(options.format) });
            }
          },
          onChangeYear: function onChangeYear(ct) {
            if ($(that).data('onchangeyear')) {
              self._runFuncByName($(that).data('onchangeyear'), window, { 'date': ct.dateFormat(options.format) });
            }
          },
          beforeShowDay: function beforeShowDay(ct) {
            if ($(that).data('beforeshow')) {
              return self._runFuncByName($(that).data('beforeshow'), window, { 'date': ct.dateFormat(options.format) });
            }
          },
          onClose: function onClose(ct, $i) {
            /* if ($('[aria-describedby]').length) {
              $('[aria-describedby]').popover('destroy');
              $('body').unbind('click.popover');
            } */
            $i.datetimepicker('destroy');
          }
        };

        $(this).datetimepicker(options).datetimepicker('show');
      });
    }
  }, {
    key: 'iniTimePicker',
    value: function iniTimePicker(selector) {
      $(selector).on('click', function () {
        var that = this;

        if ($(this).data('inline')) {
          $(that).parent().append("<i class='datepicker icon icon-calendar'></i>");
        }

        var options = {
          format: $(this).data('format') || 'H:i',
          lang: $(this).data('lang') || 'es',
          datepicker: false,
          timepicker: true,
          weeks: $(this).data('weeks') || false,
          inline: $(this).data('inline') || false,
          step: 15,
          timepickerScrollbar: true,
          onClose: function onClose(ct, $i) {
            /* if ($('[aria-describedby]').length) {
              $('[aria-describedby]').popover('destroy');
              $('body').unbind('click.popover');
            } */
            $i.datetimepicker('destroy');
          }
        };

        $(this).datetimepicker(options);
        $(this).datetimepicker('show');
      });
    }
  }, {
    key: 'iniMonthPicker',
    value: function iniMonthPicker(selector) {
      $(selector).on('click', function () {
        var that = this;
        var options = {
          format: $(this).data('format') || 'Y-m',
          lang: $(this).data('lang') || 'es',
          inline: $(this).data('inline') || false,
          defaultDate: $(this).data('default') || false,
          timepicker: false,
          dayOfWeekStart: 1,
          onGenerate: function onGenerate(ct) {
            $(that).val(ct.dateFormat(options.format));
            $(this).find('.xdsoft_calendar').hide();
          },
          onChangeMonth: function onChangeMonth(ct) {
            $(that).val(ct.dateFormat(options.format));
          },
          onChangeYear: function onChangeYear(ct) {
            $(that).val(ct.dateFormat(options.format));
          },
          onClose: function onClose(ct, $i) {
            /* if ($('[aria-describedby]').length) {
              $('[aria-describedby]').popover('destroy');
              $('body').unbind('click.popover');
            } */
            $i.datetimepicker('destroy');
          }
        };

        $(this).datetimepicker(options);
        $(this).datetimepicker('show');
      });
    }
  }, {
    key: 'inlineMonthPicker',
    value: function inlineMonthPicker(selector) {
      $(selector).each(function () {
        var date = void 0;
        var that = this;
        var options = {
          format: $(this).data('format') || 'Y-M',
          lang: $(this).data('lang') || 'es',
          inline: $(this).data('inline') || false,
          defaultDate: $(this).data('default') || false,
          timepicker: false,
          dayOfWeekStart: 1,
          onGenerate: function onGenerate(ct) {
            date = moment(ct);
            $(that).val(date.format(options.format)).change();
            $(this).find('.xdsoft_calendar').hide();
          },
          onChangeMonth: function onChangeMonth(ct) {
            date = moment(ct);
            $(that).val(date.format(options.format)).change();
          },
          onChangeYear: function onChangeYear(ct) {
            date = moment(ct);
            $(that).val(date.format(options.format)).change();
          }
        };

        $(this).datetimepicker(options);
      });
    }
  }, {
    key: 'ajaxReplace',
    value: function ajaxReplace(url, target) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var loader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var complete = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      this.ajaxLink(url, target, params, loader, complete, false, {
        type: 'replace'
      });
    }
  }, {
    key: 'ajaxLink',
    value: function ajaxLink(url, target, params, loader, complete, object, data) {
      var _this = this;

      var regexp = new RegExp("'", 'g');
      var settings = {
        url: url.replace(regexp, '') || false,
        target: target ? target.replace(regexp, '') : false,
        params: params || false,
        complete: complete || false,
        loader: loader || false,
        data: data || {}
      };

      if (this.blocked) return;

      this.blocked = true;

      if (settings.loader !== false) {
        $(object).addClass(this.settings.loader.class);
      }

      $.ajax({
        url: settings.url,
        context: document.body,
        data: settings.params,
        success: function success(data, textStatus) {
          if ($('#' + settings.target)) {
            if (data.search('<append>') !== -1) {
              $('#' + settings.target).append(data);
              if ($(data).attr('id')) {
                _this.bindAll('#' + $(data).attr('id'));
              } else {
                _this.bindAll($('#' + settings.target));
              }
            } else if (settings.data.type === 'replace') {
              $('#' + settings.target).replaceWith(data);
              if ($(data).attr('id')) {
                _this.bindAll('#' + $(data).attr('id'));
              } else {
                _this.bindAll();
              }
            } else {
              $('#' + settings.target).html(data);
              _this.bindAll($('#' + settings.target));
            }
          }

          if (settings.complete !== false) {
            _this.blocked = false;
            if ($.type(settings.complete) === 'function') {
              settings.complete(data);
            } else {
              _this._runFuncByName(settings.complete, window, data);
            }
          }

          _this.blocked = false;
          $(object).removeClass(_this.settings.loader.class);
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          _this.blocked = false;
          $(object).removeClass(_this.settings.loader.class);
        }
      });
    }
  }, {
    key: 'jsonLink',
    value: function jsonLink(url, target, params, loader, complete, object) {
      var _this2 = this;

      if (!url) {
        // console.error('Missing href attribute');
        return false;
      }

      var regexp = new RegExp("'", 'g');
      var settings = {
        url: url.replace(regexp, '') || false,
        target: target ? target.replace(regexp, '') : false,
        params: params || false,
        complete: complete || false,
        loader: loader || false,
        method: $(object).attr('method') || 'GET'
      };

      if (this.blocked) return;

      if ($(object).attr('before-submit')) {
        web._runFuncByName($(object).attr('before-submit'), window);
      }

      this.blocked = true;

      if (settings.loader !== false) {
        $(object).addClass(this.settings.loader.class);
      }

      $.ajax({
        url: settings.url,
        context: document.body,
        data: settings.params,
        dataType: 'json',
        success: function success(data, textStatus) {
          if (settings.loader !== false) {
            $(object).removeClass(_this2.settings.loader.class);
          }

          if (settings.complete) {
            _this2.blocked = false;
            if ($.type(settings.complete) === 'function') {
              settings.complete(data);
            } else {
              _this2._runFuncByName(settings.complete, window, data);
            }
          }

          _this2.blocked = false;
          $(object).find(_this2.settings.loader.selector).remove();
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          _this2.blocked = false;
          $(object).find(_this2.settings.loader.selector).remove();
        }
      });
    }
  }, {
    key: 'ajaxForm',
    value: function ajaxForm(form, target, params, loader, data) {
      var _this3 = this;

      var regexp = new RegExp("'", 'g');
      var formObj = $('#' + form);

      params = params || '';
      loader = loader || false;
      target = target ? target.replace(regexp, '') : false;
      data = data || {};

      if (this.blocked) {
        return false;
      }

      this.blocked = true;

      if (loader) {
        var submitButton = formObj.find('[type=submit]');
        submitButton.addClass(web.settings.loader.class);
      }

      $.ajax({
        url: formObj.attr('action'),
        type: formObj.attr('method'),
        data: formObj.serialize() + params,
        success: function success(data, textStatus) {
          if ($('#' + target)) {
            if (data.type === 'replace') {
              $('#' + target).replaceWith(data);
            } else {
              $('#' + target).html(data);
            }

            if (loader) {
              formObj.find(_this3.settings.loader.selector).removeClass(_this3.settings.loader.class);
            }

            _this3.bindAll($('#' + target));
          }

          _this3.blocked = false;
        },
        error: function error(xhr, ajaxOptions, thrownError) {
          if (loader) {
            formObj.find(_this3.settings.loader.selector).removeClass(_this3.setting.loader.class);
          }
          _this3.blocked = false;
        }
      });
    }
  }, {
    key: 'feedbackMsg',
    value: function feedbackMsg(type, message, target) {
      var obj = target || $('.' + this.settings.feedback['class']);
      switch (type) {
        case 'error':
          obj.addClass(this.settings.feedback.error_class);break;
        case 'warning':
          obj.addClass(this.settings.feedback.warning_class);break;
        case 'progress':
          obj.addClass(this.settings.feedback.inprogress_class);break;
        case 'correct':
          obj.addClass(this.settings.feedback.correct_class);break;
      }
      obj.html(message).show();
    }
  }, {
    key: 'inputToSelect',
    value: function inputToSelect(selector) {
      var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';

      var self = this;

      $(selector).each(function () {
        if ($(this).attr('value')) {
          var input = $(this);
          var select = $('<select></select>');

          input.replaceWith(select);
          input.removeAttr('role');

          $.each(this.attributes, function (i, attrib) {
            var name = attrib.name;
            var value = attrib.value;

            if (name === 'value') {
              var values = value.split(sep);
              $.each(values, function (i, val) {
                var opt = val.split('#');
                select.append("<option value='" + opt[0] + "'>" + opt[1] + '</option>');
              });
            } else {
              select.attr(name, value);
            }
          });

          if (input.attr('on-create')) {
            self._runFuncByName(input.attr('on-create'), window, select);
          }

          if (input.attr('on-change')) {
            select.unbind('change');
            select.on('change', function () {
              self._runFuncByName(input.attr('on-change'), window, select);
            });
          }

          if (input.attr('default') !== undefined) {
            select.val(input.attr('default')).change();
          } else {
            select.val(select.children('option:first').val()).change();
          }
        }
      });
    }
  }, {
    key: 'bindAjaxClick',
    value: function bindAjaxClick(selector) {
      var self = this;

      $(selector).unbind('click');
      $(selector).on('click', function (e) {
        e.preventDefault();

        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        if ($(this).attr('disabled') !== undefined) return false;

        self.ajaxLink($(this).attr('href'), $(this).attr('target'), false, $(this).attr('loader'), $(this).attr('after-submit'), this, $(this).data());
      });
    }
  }, {
    key: 'bindJsonClick',
    value: function bindJsonClick(selector) {
      var self = this;

      $(selector).unbind('click');
      $(selector).on('click', function (e) {
        e.preventDefault();

        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        if ($(this).attr('disabled') !== undefined) {
          return false;
        }

        self.jsonLink($(this).attr('href'), $(this).attr('target'), false, $(this).attr('loader'), $(this).attr('after-submit'), this);
      });
    }
  }, {
    key: 'bindLinkClick',
    value: function bindLinkClick(selector) {
      var self = this;

      $(selector).unbind('click').on('click', function (e) {
        e.preventDefault();

        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        if ($(this).attr('disabled') !== undefined) {
          return false;
        }

        if ($(this).attr('loader') === 'true') {
          $(this).addClass(self.settings.loader.class);
        }

        self.redirect($(this).attr('href'));
      });
    }
  }, {
    key: 'bindAjaxForm',
    value: function bindAjaxForm(selector) {
      var self = this;

      $(selector).each(function () {
        var formObj = $(this);

        if (formObj.find('input[name=close]').length === 0) {
          formObj.append("<input type='hidden' name='close' value='0'>");
        }

        formObj.find('[type=submit]').each(function () {
          $(this).unbind('click');
          $(this).on('click', function () {
            switch ($(this).attr('role')) {
              case 'save':
                formObj.find('input[name=close]').val(0);break;
              case 'save&exit':
                formObj.find('input[name=close]').val(1);break;
            }
          });
        });

        formObj.ajaxForm({
          beforeSubmit: function beforeSubmit(arr, form, ops) {
            if (self.blocked || formObj.attr('disabled') !== undefined || formObj.find('[type=submit]').attr('disabled') !== undefined) {
              return false;
            }

            self.blocked = true;

            if (formObj.attr('loader')) {
              formObj.find('[type=submit]').addClass(self.settings.loader.class);
            }

            if (formObj.attr('before-submit')) {
              return web._runFuncByName(formObj.attr('before-submit'), window);
            } else {
              formObj.addClass('sending').blur();
            }
          },
          success: function success(data, statusText, xhr, form) {
            formObj.removeClass('sending');

            if (formObj.attr('after-submit')) {
              self.blocked = false;
              self._runFuncByName(formObj.attr('after-submit'), window, data);
            }

            $('#' + formObj.attr('target')).html(data);
            self.bindAll($('#' + formObj.attr('target')));

            self.blocked = false;
            formObj.find('[type=submit]').delay(0).queue(function () {
              $(this).removeClass(self.settings.loader.class).dequeue();
            });
          },
          error: function error(xhr, ajaxOptions, thrownError) {
            self.blocked = false;
            formObj.removeClass('sending');
            formObj.find('[type=submit]').delay(0).queue(function () {
              $(this).removeClass(self.settings.loader.class).dequeue();
            });
          }
        });
      });
    }
  }, {
    key: 'parseFeedback',
    value: function parseFeedback(jQform, data) {
      var _this4 = this;

      var showFeedback = function showFeedback() {
        if (jQform.data('msg-type') === 'alert') {
          _this4.modal.alert(data.msg, data.error ? _this4.settings.feedback.error_class : _this4.settings.feedback.correct_class);
        } else {
          if (jQform.find('.' + _this4.settings.feedback.class).length === 0) {
            jQform.append("<div class='" + _this4.settings.feedback['class'] + "'></div>");
          }

          jQform.find('.' + _this4.settings.feedback['class']).html(data.msg).removeClass(data.error ? _this4.settings.feedback.correct_class : _this4.settings.feedback.error_class).addClass(data.error ? _this4.settings.feedback.error_class : _this4.settings.feedback.correct_class).fadeIn();
        }
      };

      if (!jQform.data('feedback') || jQform.data('feedback') === 'all') {
        showFeedback();
      } else if (jQform.data('feedback') === 'error') {
        if (data.error) {
          showFeedback();
        } else {
          jQform.find('.' + this.settings.feedback.class).remove();
        }
      } else if (jQform.data('feedback') === 'success') {
        if (!data.error) {
          showFeedback();
        } else {
          jQform.find('.' + this.settings.feedback['class']).remove();
        }
      }
    }
  }, {
    key: 'bindJsonForm',
    value: function bindJsonForm(selector) {
      var self = this;

      $(selector).each(function () {
        var jQform = $(this);

        if (jQform.find('input[name=close]').length === 0) {
          jQform.append("<input type='hidden' name='close' value='0'>");
        }

        jQform.find('[type=submit]').each(function () {
          $(this).unbind('click');
          $(this).on('click', function () {
            switch ($(this).attr('role')) {
              case 'save':
                jQform.find('input[name=close]').val(0);break;
              case 'save&exit':
                jQform.find('input[name=close]').val(1);break;
            }
          });
        });

        var submitButton = jQform.find('[type=submit]');

        jQform.ajaxForm({
          url: jQform.attr('action'),
          type: jQform.attr('method'),
          dataType: 'json',
          beforeSubmit: function beforeSubmit(arr, form, ops) {
            if (self.blocked || jQform.attr('disabled') !== undefined || jQform.find('[type=submit]').attr('disabled') !== undefined) {
              return false;
            }

            self.blocked = true;

            if (jQform.attr('loader')) {
              submitButton.addClass(self.settings.loader.class);
            }

            jQform.find('.' + self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
            jQform.find('.' + self.settings.feedback['class']).fadeOut('fast');

            if (jQform.attr('before-submit')) {
              return self._runFuncByName(jQform.attr('before-submit'), window);
            } else {
              jQform.addClass(self.settings.forms.sending_class).blur();
            }
          },
          success: function success(data, textStatus) {
            if (data.error) {
              if (jQform.attr('after-error')) {
                self.blocked = false;
                self._runFuncByName(jQform.attr('after-error'), window, data);
              }

              if (jQform.data('validator')) {
                jQform.find("[name='" + data.field + "']").closest(self.settings.forms.group).addClass('has-error');

                if (data.field) {
                  jQform.find("[name='" + data.field + "']").closest('input, select').focus();

                  if (jQform.data('tooltip')) {
                    self.showToolTip(jQform, data);
                  } else {
                    self.parseFeedback(jQform, data);
                  }
                } else {
                  self.parseFeedback(jQform, data);
                }
              } else {
                self.parseFeedback(jQform, data);
              }
            } else {
              self.parseFeedback(jQform, data);

              if (jQform.attr('after-submit')) {
                self.blocked = false;
                self._runFuncByName(jQform.attr('after-submit'), window, data);
              }

              if (parseInt(data.close) === 1 && self.modal) {
                self.modal.close();
              }
            }

            submitButton.removeClass(self.settings.loader.class);

            self.blocked = false;
          },
          error: function error(xhr, ajaxOptions, thrownError, form) {
            submitButton.remove();
            self.blocked = false;
          }
        });
      });
    }
  }, {
    key: 'showToolTip',
    value: function showToolTip(jQform, res) {
      if (this.popover) {
        var element = jQform.find('[name="' + res.field + '"]');
        var placement = res.data && res.data.placement;

        this.popover.tooltip(element, res.msg, placement);
      }
    }
  }, {
    key: 'bindJsonFormSubmit',
    value: function bindJsonFormSubmit(selector) {
      var self = this;

      $(selector).unbind('submit');
      $(selector).on('submit', function (e) {
        e.preventDefault();
        self.formJSONSubmit(selector);
      });
    }
  }, {
    key: 'bindUploadForm',
    value: function bindUploadForm(selector) {
      var self = this;
      $(selector).each(function () {
        var form = this;
        var input = $(form).find(':file');
        var uploadButton = $(form).find('[type=button]');

        $(form).on('submit', function () {
          var _this5 = this;

          if (self.blocked) return false;

          self.blocked = true;

          var formData = new FormData($(form)[0]);
          var preview = $(form).data('preview') || null;
          var target = $(form).data('target') || null;

          if ($(form).find('.' + self.settings.feedback.class).length === 0) {
            $(form).append("<div class='" + self.settings.feedbackclass + "'></div>");
          }

          $(form).find('.' + self.settings.loader.class).fadeIn('fast').show();
          $(form).find('.' + self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
          $(form).find('.' + self.settings.feedback.class).fadeOut('fast');

          if (uploadButton) {
            uploadButton.addClass(self.settings.loader.class);
          }

          $.ajax({
            url: $(form).attr('action'),
            type: 'post',
            data: formData,
            dataType: 'json',
            cache: false,
            contentType: false,
            processData: false,
            xhr: function xhr() {
              var myXhr = $.ajaxSettings.xhr();
              if (myXhr.upload) {
                myXhr.upload.addEventListener('progress', _this5.uploadProgress, false);
              }
              return myXhr;
            },
            success: function success(data) {
              if (!data.error) {
                if (data.msg !== false) {
                  $(form).find('.' + self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.error_class).addClass(self.settings.feedback.correct_class).fadeIn();
                }

                if (preview) {
                  $(preview).css({ 'background-image': 'url(' + data.data.path + ')' });
                }

                if (target) {
                  $(target).attr('value', data.data.filename);
                }

                if ($(form).attr('after-submit')) {
                  self.blocked = false;
                  self._runFuncByName($(form).attr('after-submit'), window, data);
                }
              } else {
                $(form).find('.' + self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.correct_class).addClass(self.settings.feedback.error_class).fadeIn();
                input.val('');
              }

              if (uploadButton) {
                $(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
              }

              self.blocked = false;
            },
            error: function error(xhr, ajaxOptions, thrownError, form) {
              if (uploadButton) {
                $(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
              }
              self.blocked = false;
            }
          });
          return false;
        });

        $('[form-id="' + $(form).attr('id') + '"]').on('click', function () {
          if (self.blocked) return false;

          $(input).trigger('click');
        });

        $(input).on('change', function () {
          if (self.blocked) return false;

          $(form).submit();
        });
      });
    }
  }, {
    key: 'uploadProgress',
    value: function uploadProgress(p) {
      // console.log(p);
    }
  }, {
    key: 'confirm',
    value: function (_confirm) {
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }

      confirm.toString = function () {
        return _confirm.toString();
      };

      return confirm;
    }(function (msg) {
      return confirm(msg);
    })
  }, {
    key: 'loginRequired',
    value: function loginRequired(settings) {
      if (!settings) {
        settings = { transition: 'bounce', forcedClose: true };
      }

      if (this.modal) {
        this.modal.open(this.settings.login_required.template);
      }
    }
  }, {
    key: 'bindLoginRequired',
    value: function bindLoginRequired(selector) {
      if (this.modal) {
        this.modal.bindOpen(selector, this.settings.login_required.template);
      }
    }
  }, {
    key: 'bindPaginator',
    value: function bindPaginator(selector, pageContainer) {
      var self = this;
      var curpag = parseInt($(selector).find('.active').attr('pag'));
      var lastpag = parseInt($(selector).find('[name=lastpage]').val());

      $(selector).on('click', '.link', function (e) {
        e.preventDefault();

        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        if (!$(this).hasClass('prev') && !$(this).hasClass('next')) {
          self.ajaxReplace($(this).attr('href'), $(this).closest(pageContainer).attr('id'), 'ipage=' + $(this).attr('pag'), false, $(this).attr('after-submit'), this, $(this).data());
        } else {
          if ($(this).attr('disabled') !== 'disabled') {
            self.ajaxReplace($(this).attr('href'), $(this).closest(pageContainer).attr('id'), 'ipage=' + parseInt(curpag + parseInt($(this).attr('pag'))), false, $(this).attr('after-submit'), this, $(this).data());
          }
        }
      });

      $(selector).on('click', '.form', function (e) {
        e.preventDefault();

        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        if (!$(this).hasClass('prev') && !$(this).hasClass('next')) {
          self.ajaxForm($(this).attr('href'), $('#' + $(this).attr('href')).attr('target'), '&ipage=' + $(this).attr('pag'), false, { type: 'replace' });
        } else {
          if ($(this).attr('disabled') !== 'disabled') {
            self.ajaxForm($(this).attr('href'), $('#' + $(this).attr('href')).attr('target'), '&ipage=' + parseInt(curpag + parseInt($(this).attr('pag'), false, { type: 'replace' })));
          }
        }
      });

      if (curpag === 1) {
        $(selector).find('.prev').attr('disabled', 'disabled').unbind('click');
      }

      if (curpag === lastpag) {
        var next = $(selector).find('.next').attr('disabled', 'disabled');
        next.unbind('click');
      }
    }
  }, {
    key: 'bindMenu',
    value: function bindMenu(menu, option, dropdownOption) {
      var loader = void 0;
      var self = this;

      $(menu).find(option).unbind('click');
      $(menu).each(function () {
        var parentMenu = this;

        $(parentMenu).find(option).each(function () {
          $(this).unbind('click');
          $(this).on('click', function (e) {
            if (self.blocked) return false;

            e.preventDefault();

            var selection = window.getSelection();
            if (selection.toString().length !== 0) {
              return false;
            }

            $(parentMenu).find(option).removeClass('active');
            $(parentMenu).find(dropdownOption).removeClass('active');

            $(this).addClass('active');

            var parentDropdownItem = $(this).parents(dropdownOption);
            if (parentDropdownItem) {
              parentDropdownItem.addClass('active');
            }

            loader = $(this).attr('loader') ? $(this).attr('loader') : $(parentMenu).attr('loader');

            if ($(this).attr('href')) {
              var target = $(this).attr('target') || $(parentMenu).attr('target');

              self.ajaxLink($(this).attr('href'), target, false, loader, $(this).attr('after-submit'), this, $(parentMenu).data());
            } else if ($(this).attr('after-submit')) {
              self.blocked = false;
              self._runFuncByName($(this).attr('after-submit'), window);
            }
          });
        });
      });
    }
  }, {
    key: 'bindOpenTab',
    value: function bindOpenTab(item) {
      var self = this;
      var tabIdPool = [];

      $(item).unbind('click');
      $(item).on('click', function () {
        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        var targetMenu = $(this).attr('target') || false;

        if (targetMenu) {
          var newTab = null;
          var newContent = null;
          var curTab = $(targetMenu).find('.active').first();
          var curContent = $("[tab-ref='" + $(curTab).attr('tab-id') + "']");
          var tabId = $(this).attr('tab-id');

          if (!tabId) {
            tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);

            while (tabIdPool.indexOf(tabId) !== -1) {
              tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);
            }

            tabIdPool.push(tabId);
            $(this).attr('tab-id', tabId);
          } else {
            if (tabIdPool.indexOf(tabId) === -1) {
              tabIdPool.push(tabId);
            }
          }

          if ($(targetMenu).find("[tab-id='" + tabId + "']").length === 0) {
            // Creamos la nueva pestaña
            newTab = $(curTab.first().clone());

            newTab.attr({ 'tab-id': tabId, 'data-href': $(this).data('href') });
            newTab.addClass('active');
            newTab.html($(this).data('tagname'));
            newTab.append("<div role='close-tab'></div>");

            if ($(this).data('close-class')) {
              newTab.find("[role='close-tab']").addClass($(this).data('close-class'));
              newTab.find("[role='close-tab']").on('click', function () {
                var prevTab = newTab.prev(self.settings.menu_tab.item);
                newTab.remove();
                $("[tab-ref='" + newTab.attr('tab-id') + "']").remove();
                prevTab.trigger('click');
              });
            }

            $(targetMenu).append(newTab);

            self.bindMenuTab(targetMenu, self.settings.menu_tab.item);
          } else {
            // La nueva pestaña ya existía
            newTab = $($(targetMenu).find("[tab-id='" + tabId + "']"));
          }

          curTab.removeClass('active');
          newTab.addClass('active');

          if ($("[tab-ref='" + newTab.attr('tab-id') + "']").length === 0) {
            newContent = curContent.clone();
            newContent.attr({ 'id': $(targetMenu).attr('target') + '-' + tabId, 'tab-ref': tabId });
            curContent.parent().append(newContent);

            if (newTab.data('href')) {
              self.ajaxLink($(this).data('href'), newContent.attr('id'), false, $(this).attr('loader'), false, this, $(this).data());
            }
          } else {
            newContent = $("[tab-ref='" + tabId + "']");
          }

          curContent.addClass('hide');
          newContent.removeClass('hide');
        }
      });

      $("[role='close-remote-tab']").on('click', function () {
        var targetMenu = $("[tab-id='" + $(this).data('target') + "']").parent(self.settings.menu_tab.selector);
        var prevTab = targetMenu.find('.active').prev(self.settings.menu_tab.item);
        var curTab = targetMenu.find("[tab-id='" + $(this).data('target') + "']");
        if ($(this).data('target')) {
          curTab.remove();
          $("[tab-ref='" + curTab.attr('tab-id') + "']").remove();
          $(prevTab).trigger('click');
        }
      });
    }
  }, {
    key: 'bindMenuTab',
    value: function bindMenuTab(menu, option) {
      var self = this;

      $(menu).find(option).unbind('click');
      $(menu).each(function () {
        var parentMenu = this;
        $(parentMenu).find(option).each(function (index) {
          if (!$(this).attr('tab-id')) {
            $(this).attr('tab-id', 'tab' + index);
          }

          var tabId = $(this).attr('tab-id');

          $(this).on('click', function (e) {
            $(parentMenu).find(option).removeClass('active');
            $(this).addClass('active');

            if ($(parentMenu).data('refresh')) {
              if ($(this).data('href')) {
                self.ajaxLink($(this).data('href'), tabId, false, $(this).attr('loader'), false, this, $(this).data());
              }
            }

            $(parentMenu).parent().find('[tab-ref]').addClass('hide');

            var menuItem = $("[tab-ref='" + tabId + "']").find('[role=menu-item].active');

            $(parentMenu).parent().find('[role=tab-nav].active').each(function (index) {
              $("[tab-ref='" + $(this).attr('tab-id') + "']").removeClass('hide');
            });

            if ($(menuItem).length > 0) {
              self.ajaxLink($(menuItem).attr('href'), $(menuItem).parent('[role=menu]').attr('target'), false, $(this).attr('loader'), false, this, $(this).data());
            }
          });
        });
      });
    }
  }, {
    key: 'bindDropdownMenu',
    value: function bindDropdownMenu(button, menu) {
      var self = this;

      $(button).each(function () {
        var obj = $(this);
        var events = false;
        var menuObj = false;

        if (obj.data('hover-open') === true) {
          events = 'click mouseenter';
        } else {
          events = 'click';
        }

        obj.unbind(events);
        obj.on(events, function (e) {
          menuObj = $(this).children(menu);
          // menuObj.parent().css({position: 'relative'});
          menuObj.css({
            display: 'auto',
            top: $(this).data('top') || '100%',
            left: $(this).data('left') || '0%'
          });

          if (menuObj.attr('visible') === 'true') {
            self.showDropdownMenu(menuObj, false);
          } else {
            self.showDropdownMenu(menuObj, true);
          }
        });

        // On mouseleave menu always hide it
        $(obj).unbind('mouseleave');
        $(obj).on('mouseleave', function (e) {
          if (menuObj) {
            self.showDropdownMenu(menuObj, false);
          }
        });
      });
    }
  }, {
    key: 'showDropdownMenu',
    value: function showDropdownMenu(menu, show) {
      if (show === true) {
        menu.attr('visible', 'true');
        menu.removeClass('hide').addClass('show');
      } else {
        menu.attr('visible', 'false');
        menu.removeClass('show').addClass('hide');
      }
    }

    /* actionDropdown (elementList, action, icon) {
      if (action === 'show') {
        elementList.removeClass('hide').addClass('show');
      } else if (action === 'hide') {
        elementList.removeClass('show').addClass('hide');
      }
    } */

  }, {
    key: 'bindMultipleCheckBox',
    value: function bindMultipleCheckBox(selector, itemsCheck) {
      $(selector).unbind('click');
      $(selector).on('click', function () {
        if ($(this).prop('checked')) {
          $(itemsCheck).prop('checked', true);
        } else {
          $(itemsCheck).prop('checked', false);
        }
      });
    }
  }, {
    key: 'redirect',
    value: function redirect(url) {
      if (url) {
        window.location.href = url;
      }
    }
  }, {
    key: 'errorHandler',
    value: function errorHandler() {
      var _this6 = this;

      $(document).unbind('ajaxError');
      $(document).on('ajaxError', function (e, xhr, settings, thrownError) {
        _this6.blocked = false;

        if (xhr.status === 412) {
          // this.loginRequired();
          _this6.redirect('/');
        }

        return false;
      });
    }
  }, {
    key: 'bindConfirm',
    value: function bindConfirm(selector) {
      var self = this;

      $(selector).unbind('click');
      $(selector).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (self.popover) {
          self.popover.create(this, 'confirm');
        }
      });
    }
  }, {
    key: 'bindDeleteClick',
    value: function bindDeleteClick(selector) {
      var self = this;

      $(selector).unbind('click');
      $(selector).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (self.popover) {
          self.popover.create(this, 'delete');
        }
      });
    }
  }, {
    key: 'bindActivate',
    value: function bindActivate(selector) {
      var self = this;

      $(selector).unbind('click');

      $(selector).each(function () {
        if (+$(this).attr('active') === 1 && $(this).data('active')) {
          if (!$(this).hasClass($(this).data('active'))) {
            $(this).removeClass($(this).data('inactive')).addClass($(this).data('active'));
          }
        } else if (+$(this).attr('active') === 0 && $(this).data('inactive')) {
          if (!$(this).hasClass($(this).data('inactive'))) {
            $(this).removeClass($(this).data('active')).addClass($(this).data('inactive'));
          }
        }

        var href = $(this).attr('href');
        if (href.indexOf('&active=') === -1) {
          href += '&active=' + $(this).attr('active');
          $(this).attr('href', href);
        }
      });

      $(selector).on('click', function (e) {
        var _this7 = this;

        e.preventDefault();
        e.stopPropagation();

        var message = '';

        if ($(this).data('confirm') && $(this).data('confirm') === true) {
          if (+$(this).attr('active') === 1) {
            message = $(this).data('offmsg') || '¿Desactivar el registro?';
          } else if (+$(this).attr('active') === 0) {
            message = $(this).data('onmsg') || '¿Activar el registro?';
          }

          if (self.popover) {
            self.popover.create(this, 'confirm', message, false, function (res) {
              var onclass = $(_this7).data('active');
              var offclass = $(_this7).data('inactive');
              var active = +res.data.active;

              $(_this7).attr('active', active);

              if (active === 0 && offclass) {
                $(_this7).removeClass(onclass).addClass(offclass);
              } else if (active === 1 && onclass) {
                $(_this7).removeClass(offclass).addClass(onclass);
              }

              var href = $(_this7).attr('href');
              href = href.replace(/&active=([0-1])/g, '&active=' + active);

              $(_this7).attr('href', href).attr('active', active);
            });
          }
        } else {
          self.activate(this);
        }
      });
    }
  }, {
    key: 'activate',
    value: function activate(obj) {
      var _this8 = this;

      if (this.blocked) return false;

      this.blocked = true;

      var onclass = $(obj).data('active');
      var offclass = $(obj).data('inactive');
      var arrlink = $(obj).attr('href').split('?');
      var active = $(obj).attr('active') || 0;
      var self = this;

      $.ajax({
        url: arrlink[0],
        data: arrlink[1] ? arrlink[1] + '&active=' + active : 'active=' + active,
        type: 'post',
        dataType: 'json',
        success: function success(res) {
          if (!res.error) {
            // $(obj).popover('destroy');
            $(obj).attr('active', res.data.active);

            if (res.data.active === 0 && offclass) {
              $(obj).removeClass(onclass).addClass(offclass);
            } else if (res.data.active === 1 && onclass) {
              $(obj).removeClass(offclass).addClass(onclass);
            }

            $(obj).attr('active', res.data.active);

            if ($(obj).attr('after-submit')) {
              self.blocked = false;
              _this8._runFuncByName($(obj).attr('after-submit'), window, res.data);
            }
          }

          _this8.blocked = false;
        }
      });
    }
  }, {
    key: 'bindToggle',
    value: function bindToggle(selector) {
      var self = this;

      $(selector).unbind('click');
      $(selector).on('click', function (e) {
        e.preventDefault();
        var selection = window.getSelection();
        if (selection.toString().length !== 0) {
          return false;
        }

        var link = $(this).attr('href') || false;
        var target = $(this).attr('target') || false;

        if (target) {
          var that = $(this);

          if ($(this).find('.icon').length !== 0) {
            if ($(this).find('.icon').hasClass($(this).data('closed'))) {
              $(this).find('.icon').removeClass($(this).data('closed')).addClass($(this).data('opened'));
              if (link) {
                self.ajaxLink(link, target, false, false, function () {
                  $('#' + target).removeClass('collapsed');

                  if (that.attr('after-open')) {
                    self.blocked = false;
                    self._runFuncByName(that.attr('after-open'), window, false);
                  }
                }, this, $(this).data());
              } else {
                $('#' + target).removeClass('collapsed');
                if (that.attr('after-open')) {
                  self.blocked = false;
                  self._runFuncByName(that.attr('after-open'), window, false);
                }
              }
            } else {
              $(this).find('.icon').removeClass($(this).data('opened')).addClass($(this).data('closed'));
              $('#' + target).addClass('collapsed');
              if (that.attr('after-close')) {
                self.blocked = false;
                self._runFuncByName(that.attr('after-close'), window, false);
              }
            }
          } else {
            if ($(this).hasClass($(this).data('closed'))) {
              $(this).removeClass($(this).data('closed')).addClass($(this).data('opened'));
              if (link) {
                self.ajaxLink(link, target, false, false, function () {
                  $('#' + target).removeClass('collapsed');
                  if (that.attr('after-open')) {
                    self.blocked = false;
                    self._runFuncByName(that.attr('after-open'), window, false);
                  }
                }, this, $(this).data());
              } else {
                $('#' + target).removeClass('collapsed');
                if (that.attr('after-open')) {
                  self.blocked = false;
                  self._runFuncByName(that.attr('after-open'), window, false);
                }
              }
            } else {
              $(this).removeClass($(this).data('opened')).addClass($(this).data('closed'));
              $('#' + target).addClass('collapsed');
              if (that.attr('after-close')) {
                self.blocked = false;
                self._runFuncByName(that.attr('after-close'), window, false);
              }
            }
          }
        }
      });
    }
  }, {
    key: 'bindInputGroup',
    value: function bindInputGroup(selector, type) {
      var self = this;
      $(selector).each(function () {
        var group = $(this);
        var inputs = group.find('input:' + type);

        $(inputs).hide();

        $(inputs).each(function () {
          if (group.attr('default') === $(this).val()) {
            $(this).prop('checked', true);
            $(this).parent().addClass('checked');
          } else {
            $(this).prop('checked', false);
            $(this).parent().removeClass('checked');
          }
        });

        $(inputs).on('click', function () {
          if (type === 'radio') {
            $(inputs).each(function () {
              $(this).parent().removeClass('checked');
            });

            $(this).parent().addClass('checked');
          } else if (type === 'checkbox') {
            if ($(this).prop('checked') === true) {
              $(this).parent().addClass('checked');
            } else {
              $(this).parent().removeClass('checked');
            }
          }
        });

        if (group.attr('on-change')) {
          $(inputs).unbind('change');
          $(inputs).on('change', function () {
            self._runFuncByName(group.attr('on-change'), window, $(this));
          });
        }
      });
    }
  }, {
    key: '_runFuncByName',
    value: function _runFuncByName(functionCall, context, extra) {
      var args = void 0;

      if (this.settings.useEval === 'true') {
        if (extra && functionCall[0] !== '$') {
          args = /\b[^()]+\((.*)\).?$/.exec(functionCall);
          if (args && args[1]) {
            functionCall = functionCall.replace(/\(.*\)/, '(' + args[1] + ', extra)');
          } else {
            functionCall = functionCall.replace(/\(.*\)/, '(extra)');
          }
        }

        return eval(functionCall);
      } else {
        args = functionCall.match(/\(([^)]+)\)/);

        if (args !== null) {
          args = args[1].split(',');
          args.forEach(function (item, i) {
            args[i] = item.trim();
          });
        } else {
          args = [];
        }

        var functionName = functionCall.split('(');
        var namespaces = functionName[0].split('.');
        var func = namespaces.pop();

        for (var i = 0; i < namespaces.length; i++) {
          context = context[namespaces[i]];
        }

        if (extra) {
          args.push(extra);
        }

        if (context[func]) {
          return context[func].apply(context, args);
        } else {
          return false;
        }
      }
    }
  }, {
    key: 'bindCaptcha',
    value: function bindCaptcha(selector, key) {
      var _this9 = this;

      var self = this;

      setTimeout(function () {
        if (_this9.grecaptcha) {
          $.each($(selector), function () {
            self.grecaptcha.render(this, {
              'sitekey': key
            });
          });
        }
      }, 1000);
    }
  }, {
    key: 'bindAll',
    value: function bindAll(context) {
      context = context || document;

      this.errorHandler();
      // Links
      if (this.settings.links) {
        if (this.settings.links.link) {
          this.bindLinkClick($(context).find(this.settings.links.link));
        }

        if (this.settings.links.ajax) {
          this.bindAjaxClick($(context).find(this.settings.links.ajax));
        }

        if (this.settings.links.json) {
          this.bindJsonClick($(context).find(this.settings.links.json));
        }
      }

      // Forms
      if (this.settings.forms) {
        if (this.settings.forms.ajax) {
          this.bindAjaxForm($(context).find('form' + this.settings.forms.ajax));
        }

        if (this.settings.forms.json) {
          this.bindJsonForm($(context).find('form' + this.settings.forms.json));
        }

        if (this.settings.forms.upload) {
          this.bindUploadForm($(context).find('form' + this.settings.forms.upload));
        }
      }

      // Paginator
      if (this.settings.paginator) {
        this.bindPaginator($(context).find(this.settings.paginator.selector), this.settings.paginator.content);
      }

      // Login required
      if (this.settings.login_required) {
        this.bindLoginRequired($(context).find(this.settings.login_required.selector));
      }

      // Menu
      if (this.settings.menu) {
        this.bindMenu($(context).find(this.settings.menu.selector), this.settings.menu.item, this.settings.dropdown.selector);
      }

      // Menu-Tab
      if (this.settings.menu_tab) {
        this.bindMenuTab($(context).find(this.settings.menu_tab.selector), this.settings.menu_tab.item);
        this.bindOpenTab($(context).find(this.settings.menu_tab.tab_new));
      }

      // DatePicker
      if (this.settings.datepicker) {
        this.iniDatePicker($(context).find(this.settings.datepicker.selector));
      }

      // TimePicker
      if (this.settings.timepicker) {
        this.iniTimePicker($(context).find(this.settings.timepicker.selector));
      }

      // MonthPicker
      if (this.settings.monthpicker) {
        this.iniMonthPicker($(context).find(this.settings.monthpicker.selector));
      }

      // Input to Select
      if (this.settings.input_to_select) {
        this.inputToSelect($(context).find(this.settings.input_to_select.selector), this.settings.input_to_select.separator);
      }

      // Dropdown menu
      if (this.settings.dropdown) {
        this.bindDropdownMenu($(context).find(this.settings.dropdown.selector), this.settings.dropdown.list);
      }

      // Confirm
      if (this.settings.confirm) {
        this.bindConfirm($(context).find(this.settings.confirm.selector));
      }

      // Activate
      if (this.settings.activate) {
        this.bindActivate($(context).find(this.settings.activate.selector));
      }

      // Delete
      if (this.settings.delete) {
        this.bindDeleteClick($(context).find(this.settings.delete.selector));
      }

      // Toggle
      if (this.settings.toggle) {
        this.bindToggle($(context).find(this.settings.toggle.selector));
      }

      // Check buttons group
      if (this.settings.checkboxgroup) {
        this.bindInputGroup($(context).find(this.settings.checkboxgroup.selector), 'checkbox');
      }

      // Radio buttons group
      if (this.settings.radiogroup) {
        this.bindInputGroup($(context).find(this.settings.radiogroup.selector), 'radio');
      }

      if (this.settings.forms && this.settings.forms.google_captcha) {
        this.bindCaptcha($(context).find(this.settings.forms.google_captcha), this.settings.forms.google_captcha_key);
      }

      if (this.modal) {
        this.modal.bindAll(context);
      }

      if (this.custom) {
        this.custom.bindAll(context);
      }

      if (this.onBindAll) {
        this.onBindAll(context);
      }
    }
  }]);

  return App;
}();

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Popper */
var Popover = exports.Popover = function () {
  function Popover(App, settings) {
    _classCallCheck(this, Popover);

    this.popOpts = {
      trigger: 'manual',
      html: 'true'
    };

    this.App = App;
    this.settings = settings || {};
    this.list = [];
  }

  _createClass(Popover, [{
    key: 'tooltip',
    value: function tooltip(element, message) {
      var placement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this.create(element, 'tooltip', message, placement);
    }
  }, {
    key: 'buildPopover',
    value: function buildPopover(element, type, message) {
      var placement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (!placement) {
        placement = $(element).data('position') || 'top';
      }

      if (!$(element).data('message') && !message) {
        switch (type) {
          case 'confirm':
            message = '¿Confirmar acción?';break;
          case 'delete':
            message = '¿Eliminar registro?';break;
        }
      } else {
        if ($(element).data('message')) {
          message = $(element).data('message');
        }
      }

      var index = this.list.length;
      var buttons = '';

      if (type === 'confirm' || type === 'delete') {
        buttons = '<div class="popper-buttons">\n        <button role="popbut-yes" class="button" type="button">S\xED</button>\n        <button role="popbut-no" class="button" type="button">No</button>\n      </div>';
      }

      var html = '<div id="popper-' + index + '" class="popper">\n      <div class="popper__arrow"></div>\n      <div class="popper-content">\n        <div class="popper-message">' + message + '</div>\n        ' + buttons + '\n      </div>\n    </div>';

      $(element).attr('popper-id', 'popper-' + index);

      return {
        id: 'popper-' + index,
        html: html,
        message: message,
        placement: placement,
        fixed: $(element).attr('fixed') === 'true'
      };
    }
  }, {
    key: 'destroy',
    value: function destroy(popperId) {
      var item = this.list.filter(function (item) {
        return item.id === popperId;
      })[0];

      if (item) {
        var fixed = $('[popper-id="' + item.id + '"]').attr('fixed');
        if (fixed && fixed === 'true') {
          return;
        }

        item.popper.destroy();
        var popper = document.getElementById(popperId);
        if (popper) {
          popper.remove();
        }

        this.list = this.list.filter(function (item) {
          return item.id !== popperId;
        });
        $('[popper-id=' + popperId + ']').removeAttr('popper-id');
      }
    }
  }, {
    key: 'exists',
    value: function exists(popperId) {
      return this.list.filter(function (item) {
        return item.id === popperId;
      })[0];
    }
  }, {
    key: 'create',
    value: function create(element, type) {
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var _this = this;

      var placement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if ($(element).attr('popper-id') && this.exists($(element).attr('popper-id'))) {
        return;
      } else {
        this.list.forEach(function (item) {
          _this.destroy(item.id);
        });
      }

      var data = this.buildPopover(element, type, message, placement);

      // $('body').append(data.html);
      $(element).parent().append(data.html);

      var popper = document.getElementById(data.id);

      var newPopper = new Popper(element, popper, {
        placement: data.placement,
        modifiers: {
          flip: {
            behavior: ['left', 'bottom', 'top', 'right']
          },
          preventOverflow: {
            boundariesElement: document.querySelector('body')
          }
        }
      });

      this.bindButtons(data.id, element, type, callback);

      if (!data.fixed) {
        this.bindDismiss(data.id);
      }

      this.list.push({
        id: data.id,
        popper: newPopper
      });
    }
  }, {
    key: 'bindButtons',
    value: function bindButtons(popperId, button, type) {
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var self = this;
      var url = $(button).attr('href');
      var loader = $(button).attr('loader') || false;
      var popper = $('#' + popperId);

      popper.find('[role=popbut-yes]').unbind('click').on('click', function () {
        self.App.jsonLink(url, false, false, loader, function (data) {
          self.handleResult(data, popperId, button, type, callback);
        }, button);
      });

      popper.find('[role=popbut-no]').unbind('click').on('click', function () {
        self.destroy(popperId);
      });
    }
  }, {
    key: 'bindDismiss',
    value: function bindDismiss(popperId) {
      var _this2 = this;

      $('body, html, .modal-content').unbind('click.dismiss-popover-' + popperId).on('click.dismiss-popover-' + popperId, function (event) {
        event.stopPropagation();
        var selectors = [];
        var settings = _this2.settings;

        selectors.push('.popper-content');
        if (settings.confirm.selector) {
          selectors.push(settings.confirm.selector);
        }

        if (settings.delete.selector) {
          selectors.push(settings.delete.selector);
        }

        if (settings.activate.selector) {
          selectors.push(settings.activate.selector);
        }

        selectors.push('.popper-buttons');

        if (!$(event.target).is(selectors.join(','))) {
          _this2.destroy(popperId);
          $('body, html, .modal-content').unbind('click.dismiss-popover-' + popperId);
        }
      });
    }
  }, {
    key: 'handleResult',
    value: function handleResult(data, popperId, button, type) {
      var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var settings = this.settings;

      if (data.error === false) {
        if ($(button).attr('close-modal') || $(button).attr('close-modal') === 'true') {
          if (this.App.modal) {
            this.App.modal.close();
          }
        }

        if (($(button).attr('remove') || $(button).attr('remove') !== '') && type === 'delete') {
          $($(button).attr('remove')).remove();
        }

        if (!$(button).attr('destroy') && $(button).attr('destroy') !== 'false') {
          this.destroy(popperId);
        }

        if ($(button).attr('after-submit')) {
          this.App._runFuncByName($(button).attr('after-submit'), window, data);
        }

        if (callback) {
          callback(data);
        }
      } else {
        if ($('#' + popperId).find('.' + settings.feedback.class).length === 0) {
          $('#' + popperId).children('.popper-content').append('<div class="' + settings.feedback.class + '"></div>');
        }

        if ($(button).attr('after-error')) {
          this.App._runFuncByName($(button).attr('after-error'), window, data);
        }

        $('#' + popperId).find('.' + settings.feedback.class).removeClass(settings.feedback.correct_class).addClass(settings.feedback.error_class).html(data.msg).fadeIn();
      }
    }
  }]);

  return Popover;
}();

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebModal = exports.WebModal = function () {
  function WebModal() {
    var App = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WebModal);

    this.App = App;
    this.triggerButton = null;
    this.opened = false;
    this.settings = settings;
    this.config = {
      width: 0,
      height: 0
    };
    this.customSettings = {};
  }

  _createClass(WebModal, [{
    key: 'open',
    value: function open(url) {
      var _this = this;

      $(this.settings.id).remove();

      var _modal = $('body').append('\n      <div id="modal-window" class="modal-window">\n        <div class="modal-holder"></div>\n      </div>');

      _modal.find('.modal-holder').load(url, function () {
        if (_this.App.blocked) return false;
        _this.App.blocked = true;
        _this.load();
      });
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      var _modal = $(this.settings.id);
      var holder = _modal.find('.modal-holder');
      var content = _modal.find('[role=modal-main]');

      _modal.fadeIn('fast');
      _modal.unbind('click').on('click', function (e) {
        _this2.close();
      });

      this.opened = true;

      $(window).on('keydown.modal', function (e) {
        if (e.which === 27) {
          _this2.close();
        }
      });

      if (this.customSettings.closeButton !== false) {
        holder.append(this.settings.closeButton);
      }

      holder.css('max-width', content.data('width') || 'auto');
      holder.css('max-height', content.data('height') || 'auto');

      holder.on('click', function (e) {
        e.stopPropagation();
      });

      this.bindClose(this.settings.selectors.close);

      if (this.customSettings.onComplete) {
        if ($.type(this.customSettings.onComplete) === 'function') {
          this.customSettings.onComplete();
        } else {
          this.App._runFuncByName(this.customSettings.onComplete, window);
        }
      }

      this.App.blocked = false;
      this.App.bindAll(_modal);

      $(content).find('input:first').focus();
    }
  }, {
    key: 'bindOpen',
    value: function bindOpen(selector, url) {
      var that = this;

      $(selector).unbind('click');
      $(selector).on('click', function (e) {
        e.preventDefault();

        that.triggerButton = this;
        that.customSettings = {
          closeButton: $(this).data('closebut'),
          loader: $(this).attr('loader') || false,
          transition: $(this).data('transition') || null,
          onComplete: $(this).attr('on-complete') || null,
          onClose: $(this).attr('on-close') || null
        };

        if (that.App.settings.loader) {
          $(this).append(that.App.settings.loader.html);
        }

        that.open(url !== undefined ? url : $(this).attr('href'), $(this));
      });
    }
  }, {
    key: 'close',
    value: function close() {
      $(window).off('keydown.modal');

      $(this.settings.id).fadeOut('fast').find('.modal-content').html('');

      if (this.customSettings.onClose) {
        if ($.type(this.customSettings.onClose) === 'function') {
          this.customSettings.onClose(this.triggerButton);
        } else {
          this.App._runFuncByName(this.customSettings.onClose, window, this.triggerButton);
        }
      }
      this.opened = false;
      this.customSettings = {};
    }
  }, {
    key: 'alert',
    value: function alert(msg, msgClass) {
      var _modal = $(this.settings.id);

      this.customSettings.closeButton = false;

      var html = '<div role="modal-main" class="feedback-message-modal ' + msgClass + '">\n      <span>' + msg + '</span>\n    </div>';

      _modal.find('.modal-content').html(html);
      this.load();
    }
  }, {
    key: 'bindClose',
    value: function bindClose(selector) {
      var _this3 = this;

      $(selector).unbind('click');
      $(selector).on('click', function () {
        _this3.close();
      });
    }
  }, {
    key: 'bindAll',
    value: function bindAll(context) {
      this.bindOpen($(context).find(this.settings.selectors.open));
    }
  }]);

  return WebModal;
}();

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomModule = exports.CustomModule = function () {
  function CustomModule() {
    var App = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, CustomModule);

    this.App = App;
  }

  _createClass(CustomModule, [{
    key: 'bindAll',
    value: function bindAll(context) {
      $('#web-message [role=close]').on('click', function () {
        $('#web-message').remove();
      });
    }
  }]);

  return CustomModule;
}();

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(139);

__webpack_require__(140);

__webpack_require__(141);

__webpack_require__(142);

__webpack_require__(143);

__webpack_require__(144);

__webpack_require__(145);

__webpack_require__(146);

__webpack_require__(147);

__webpack_require__(148);

__webpack_require__(149);

__webpack_require__(150);

__webpack_require__(151);

__webpack_require__(152);

__webpack_require__(153);

__webpack_require__(154);

__webpack_require__(155);

__webpack_require__(156);

__webpack_require__(157);

__webpack_require__(158);

//landing styles
/* Main styles */
__webpack_require__(122);
__webpack_require__(159);

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 151:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

module.exports = {"useEval":"true","holderId":"#holder","datepicker":{"selector":"[role=datepicker]"},"monthpicker":{"selector":"[role=monthpicker]"},"inlinemonthpicker":{"selector":"[role=inline-monthpicker]"},"loader":{"selector":".loader","html":"","class":"loader"},"feedback":{"class":"feedback-message","html":"<div></div>","error_class":"error","warning_class":"warning","inprogress_class":"progress","correct_class":"ok"},"links":{"ajax":"[role=ajax]","ajax_no_loader":"[role=ajax-nl]","json":"[role=json]","link":"[role=link]"},"forms":{"json":"[role=json-form]","ajax":"[role=ajax-form]","upload":"[role=upload-form]","group":".form-group","error_class":"has-error","sending_class":"sending","google_captcha":"[role=captcha]","google_captcha_key":"6LcFxyMUAAAAAO1ew7TI1hy5FUuCoQCw5tkUHsrB"},"paginator":{"selector":"[role=paginator]","content":"[role=page-content]"},"menu":{"selector":"[role=menu]","item":"[role=menu-item]"},"menu_tab":{"selector":"[role=tab-menu]","item":"[role=tab-nav]","tab_new":"[role=tab-new]"},"dropdown":{"selector":"[role=dropdown-menu]","list":"[role=dropdown-list]"},"input_to_select":{"selector":"[role=combo]","separator":"::"},"login_required":{"selector":"[role=doLogin]","template":"/t/web/login-required"},"confirm":{"selector":"[role=confirm]"},"activate":{"selector":"[role=activate]"},"delete":{"selector":"[role=delete]"},"toggle":{"selector":"[role=toggle-detail]"},"checkboxgroup":{"selector":"[role=checkbox-group]"},"radiogroup":{"selector":"[role=radio-group]"},"modal":{"id":"#modal-window","selectors":{"open":"[role=open-modal]","close":"[role=close-modal]"},"closeButton":"<div role='close-modal' class='close-button'></div>"}}

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Landing = function () {
    function Landing() {
        var AppWeb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        _classCallCheck(this, Landing);

        this.AppWeb = AppWeb;
    }

    _createClass(Landing, [{
        key: 'bindLandingTextActive',
        value: function bindLandingTextActive() {
            $('#lTextActive').change(function () {
                if ($('#lTextActive').prop('checked')) {
                    $('#landingTextBox').css('display', 'block');
                } else {
                    $('#landingTextBox').css('display', 'none');
                }
            });
        }
    }, {
        key: 'bindLandingFooterActive',
        value: function bindLandingFooterActive() {
            $('#lFooterActive').change(function () {
                if ($('#lFooterActive').prop('checked')) {
                    $('#landingFooterBox').css('display', 'block');
                } else {
                    $('#landingFooterBox').css('display', 'none');
                }
            });
        }
    }, {
        key: 'bindLandingEditBoxes',
        value: function bindLandingEditBoxes() {
            if ($('#editLandingView').length) {
                if ($('.textVisible').length) {
                    $('#landingTextBox').css('display', "block");
                }
                if ($('.footerVisible').length) {
                    $('#landingFooterBox').css('display', "flex");
                }
            }
        }
    }, {
        key: 'bindLandinfBackColorChange',
        value: function bindLandinfBackColorChange() {
            if ($('#editLandingView').length || $('#newLandingView').length) {
                $('#lBackColor').change(function () {
                    var bckColor = $('#lBackColor').val();
                    $('#lBackColorExample').css({
                        'display': 'block',
                        'background-color': bckColor
                    });
                });
            }
        }
    }, {
        key: 'showBackColor',
        value: function showBackColor() {
            var bckColor = "#" + $('#lBackColor').val();
            $('#landingNewBackColor').css('background-color', bckColor);
        }
    }, {
        key: 'bindColorPicker',
        value: function bindColorPicker() {
            if ($('#newLandingView') || $('#editLandingView')) {
                console.log('loading spectrummmm');
                $('#lBackColor').spectrum({
                    allowEmpty: true,
                    showInput: true,
                    className: "full-spectrum",
                    showInitial: true,
                    showPalette: true,
                    showSelectionPalette: true,
                    maxSelectionSize: 10,
                    preferredFormat: "hex",
                    localStorageKey: "spectrum.demo",
                    palette: [["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", "rgb(204, 204, 204)", "rgb(217, 217, 217)", "rgb(255, 255, 255)"], ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"], ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)", "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)", "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)", "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)", "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)", "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)", "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)", "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)", "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)", "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]]
                });
            }
        }
    }, {
        key: 'bindTextColorPicker',
        value: function bindTextColorPicker() {
            if ($('#newLandingView') || $('#editLandingView')) {
                console.log('loading spectrummmm new');
                $('.lTextColor').spectrum({
                    showInput: true,
                    className: "full-spectrum",
                    showInitial: true,
                    showPalette: true,
                    showSelectionPalette: true,
                    maxSelectionSize: 10,
                    preferredFormat: "hex",
                    localStorageKey: "spectrum.demo",
                    palette: [["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)", "rgb(204, 204, 204)", "rgb(217, 217, 217)", "rgb(255, 255, 255)"], ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"], ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)", "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)", "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)", "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)", "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)", "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)", "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)", "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)", "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)", "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]]
                });
            }
        }
    }, {
        key: 'bindAll',
        value: function bindAll(context) {
            this.bindLandingTextActive();
            this.bindLandingFooterActive();
            this.bindLandingEditBoxes();
            this.bindLandinfBackColorChange();
            this.bindColorPicker();
            this.bindTextColorPicker();
        }
    }]);

    return Landing;
}();

module.exports = Landing;

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageLoader = function () {
    function ImageLoader() {
        var AppWeb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        _classCallCheck(this, ImageLoader);

        this.AppWeb = AppWeb;
    }

    _createClass(ImageLoader, [{
        key: 'landingLogoLoader',
        value: function landingLogoLoader(element) {
            if (element.files && element.files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('#logoImage').attr('src', e.target.result);
                };
                $('#logoViewer').css('display', 'block');
                reader.readAsDataURL(element.files[0]);
            }
        }
    }, {
        key: 'bindAll',
        value: function bindAll(context) {}
    }]);

    return ImageLoader;
}();

module.exports = ImageLoader;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LandingsTable = function () {
    function LandingsTable() {
        var AppWeb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        _classCallCheck(this, LandingsTable);

        this.AppWeb = AppWeb;
    }

    _createClass(LandingsTable, [{
        key: 'bindLandingActiveChange',
        value: function bindLandingActiveChange(element) {
            $('.landingActiveChange').change(function () {
                var landing = $(this).attr('data-landing');
                var isCheched = $(this).prop('checked');
                $.ajax({
                    url: '/web/activateLanding',
                    data: { checked: isCheched, id: landing },
                    dataType: "json",
                    type: "post",
                    success: function success(data) {}
                });
            });
        }
    }, {
        key: 'bindAll',
        value: function bindAll() {
            this.bindLandingActiveChange();
        }
    }]);

    return LandingsTable;
}();

module.exports = LandingsTable;

/***/ })

},[133]);


// WEBPACK FOOTER //
// dist/web.a43b5bccedbdd3f7dda1.bundle.js